import { Routes, Route, Navigate } from "react-router-dom";
import { Home, CalendarPlus, ClipboardList, Building2, MoreHorizontal, CheckSquare } from "lucide-react";
import Shell from "../../components/Shell";
import { useAuth } from "../../context/AuthContext";
import useApprovalsCount from "../../lib/useApprovalsCount";
import useGalleryEnabled from "../../lib/useGalleryEnabled";
import ClientDashboard from "./ClientDashboard";
import NewBooking from "./NewBooking";
import ClientBookings from "./ClientBookings";
import ClientBookingDetail from "./ClientBookingDetail";
import ClientReportView from "./ClientReportView";
import ClientApartments from "./ClientApartments";
import ClientApprovals from "./ClientApprovals";
import ClientReferrals from "./ClientReferrals";
import ClientTutorial from "./ClientTutorial";
import ClientContact from "./ClientContact";
import ClientProfile from "./ClientProfile";
import ClientTimeline from "./ClientTimeline";
import ClientContracts from "./ClientContracts";
import ClientContractView from "./ClientContractView";
import SupervisionReportsList from "../reports/SupervisionReportsList";
import SupervisionReportDetail from "../reports/SupervisionReportDetail";

function buildNav(approvalsTotal, galleryEnabled) {
  const items = [
    { key: "dashboard", path: "/cliente", label: "Início" },
    { key: "apartments", path: "/cliente/alojamentos", label: "Alojamentos" },
    { key: "new", path: "/cliente/agendar", label: "Agendar limpeza" },
    { key: "bookings", path: "/cliente/reservas", label: "Minhas reservas" },
    { key: "approvals", path: "/cliente/aprovacoes", label: "Aprovações", badge: approvalsTotal },
    { key: "reports", path: "/cliente/relatorios", label: "Relatórios" },
    { key: "contracts", path: "/cliente/contratos", label: "Contratos" },
    { key: "history", path: "/cliente/historico", label: "Histórico" },
    { key: "referrals", path: "/cliente/indicacoes", label: "Indicações" },
    { key: "profile", path: "/cliente/perfil", label: "O meu perfil" },
    { key: "contact", path: "/cliente/contacto", label: "Contacto" },
    { key: "tutorial", path: "/cliente/tutorial", label: "Tutorial" },
  ];
  if (galleryEnabled) {
    items.push({ key: "gallery", path: "/galeria", label: "Galeria" });
  }
  return items;
}

function buildBottomNav(approvalsTotal) {
  return [
    { key: "dashboard",  path: "/cliente",             label: "Início",   icon: Home },
    { key: "apartments", path: "/cliente/alojamentos", label: "Imóveis",  icon: Building2 },
    { key: "new",        path: "/cliente/agendar",     label: "Agendar",  icon: CalendarPlus },
    { key: "approvals",  path: "/cliente/aprovacoes",  label: "Aprovar",  icon: CheckSquare, badge: approvalsTotal },
    { key: "more",       label: "Mais", icon: MoreHorizontal },
  ];
}

export default function ClientApp() {
  const { user } = useAuth() || {};
  const approvals = useApprovalsCount(user?.role);
  const galleryEnabled = useGalleryEnabled();
  const NAV = buildNav(approvals.total, galleryEnabled);
  const BOTTOM_NAV = buildBottomNav(approvals.total);
  return (
    <Shell title="Área Cliente" nav={NAV} testIdPrefix="client" bottomNavItems={BOTTOM_NAV}>
      <Routes>
        <Route index element={<ClientDashboard />} />
        <Route path="alojamentos" element={<ClientApartments />} />
        <Route path="agendar" element={<NewBooking />} />
        <Route path="reservas" element={<ClientBookings />} />
        <Route path="reservas/:bid" element={<ClientBookingDetail />} />
        <Route path="reservas/:bid/relatorio" element={<ClientReportView />} />
        <Route path="relatorios" element={<SupervisionReportsList basePath="/cliente/relatorios" />} />
        <Route path="relatorios/:id" element={<SupervisionReportDetail basePath="/cliente/relatorios" />} />
        <Route path="contratos" element={<ClientContracts />} />
        <Route path="contratos/:cid" element={<ClientContractView />} />
        <Route path="historico" element={<ClientTimeline />} />
        <Route path="aprovacoes" element={<ClientApprovals />} />
        <Route path="indicacoes" element={<ClientReferrals />} />
        <Route path="contacto" element={<ClientContact />} />
        <Route path="tutorial" element={<ClientTutorial />} />
        <Route path="perfil" element={<ClientProfile />} />
        <Route path="*" element={<Navigate to="/cliente" replace />} />
      </Routes>
    </Shell>
  );
}
